import * as flights from '../../flights';

export class BaggageFilter {
    none = false;
    with = false;

    get touched(): boolean {
        return this.none || this.with;
    }

    clear() {
        this.none = false;
        this.with = false;
    }

    check(flight: flights.FlightModel): boolean {
        let result = true; // By default filter is not applied

        if (this.none || this.with) {
            result = false; // Filter defined so hide flight by default

            if (this.none && !this.hasBaggage(flight.legs[0])) {
                return true;
            }

            if (this.with && this.hasBaggage(flight.legs[0])) {
                return true;
            }
        }

        return result;
    }

    hasBaggage(leg: flights.LegModel): boolean {
        return leg.baggage && (leg.baggage.pieceWeight > 0 || leg.baggage.pieces > 0);
    }

    hasBaggageCabin(leg: flights.LegModel): boolean {
        return leg.baggageCabin && (leg.baggageCabin.pieceWeight > 0 || leg.baggageCabin.pieces > 0);
    }
}
